/**
 * plugins/vuetify.ts
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

// Composables
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';


// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides


const lightTheme = {
  dark: false,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#43a047',
    'primary-darken-1': '#43a047',
    secondary: '#186c1b',
    'secondary-darken-1': '#186c1b',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  },
}

const darkTheme = {
  dark: true,
  colors: {
    background: '#FFFFFF',
    surface: '#FFFFFF',
    primary: '#43a047',
    'primary-darken-1': '#43a047',
    secondary: '#186c1b',
    'secondary-darken-1': '#186c1b',
    error: '#FF5252',
    info: '#2196F3',
    // info: '#448aff',
    success: '#4CAF50',
    warning: '#FFC107',
  },
}

export default createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

// export default createVuetify({
//   icons: {
//     // iconfont: 'md',
//     iconfont: "mdi,
//   },
//   theme: {
//     themes: {
//       light: {
//         // primary: '#43a047',
//         // secondary: '#186c1b',
//         primary: '#43a047',
//         secondary: '#186c1b',
//         accent: '#82B1FF',
//         error: '#FF5252',
//         info: '#2196F3',
//         success: '#4CAF50',
//         warning: '#FFC107',
//         darkL: "#1e1e1e"
//       },
//       dark: {
//         primary: '#43a047',
//         secondary: '#186c1b',
//       },
//     },
//   },
// })
